import {Fragment, observer, React} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {BuilderCardLoader, CatalogItemPreviewMenuItem, ContextMenuItem, DefaultCatalogContextMenuItems, FilterForCatalogFieldValue, GroupByThisCatalogFieldMenuItem, OpenInC8MenuItem, OpenInWorkspaceMenuItem, useCatalogDataItemUIStore, useCatalogItemsListStore, useFilterChipStore} from '@modules'
import { useCatalog} from '@stores'

export const CatalogItemsListItemContextMenu = observer(function CatalogItemsListItemContextMenu() {
  const {data, id, field, store: {library, libraryWorkspace}} = useCatalogDataItemUIStore(),
    catalog = useCatalog()

  //console.log({data, id, field, library, libraryWorkspace})
  return (
    <Fragment>
      {field && <Fragment>
	      <FilterForCatalogFieldValue field={field.field} title={data.title} value={id}/>
	      <GroupByThisCatalogFieldMenuItem field={field.field}/>
      </Fragment>}

      {libraryWorkspace?.catalog?.index &&
       <CatalogItemPreviewMenuItem library={library} data={data} workspace={libraryWorkspace} index={libraryWorkspace.catalog.index} dividerAfter>
           <BuilderCardLoader id={id}  esIndex={libraryWorkspace.catalog.index} levelOfDetail={1} hideButtons isPopover imageSource='images'/>
       </CatalogItemPreviewMenuItem> }
      {libraryWorkspace && libraryWorkspace != catalog.workspaceConfig ? <Fragment>
	      <OpenInWorkspaceMenuItem workspace={libraryWorkspace} id={id}/>
      </Fragment> : String(id).startsWith('C') && <OpenInC8MenuItem dividerBefore id={id}/>}
      <MenuDivider />
      <DefaultCatalogContextMenuItems/>
    </Fragment>)
});

export const CatalogItemsListContextMenu = observer(function CatalogItemsListItemContextMenu() {
  const store = useCatalogItemsListStore(),
    catalog = useCatalog()

  const {libraryWorkspace, catalogField, assignableField} = store,
    field = assignableField ?? catalogField
  return (
    <Fragment>
      {field && <GroupByThisCatalogFieldMenuItem field={field.field}/>}
      {libraryWorkspace?.catalog?.index && libraryWorkspace && libraryWorkspace != catalog.workspaceConfig && <Fragment>
		  <OpenInWorkspaceMenuItem workspace={libraryWorkspace} />
	  </Fragment>}
      <MenuDivider />
      <DefaultCatalogContextMenuItems/>
    </Fragment>)
});



// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/CatalogItemsListItemContextMenu.tsx